import type { RootState } from '../index'

export const getPageInfo = (state: RootState) =>
  state.potentialProducers?.pageInfo ?? null

const emptyArray = []
export const getItems = (state: RootState) =>
  state.potentialProducers?.items ?? emptyArray

export const getSorting = (state: RootState) =>
  state.potentialProducers?.sorting ?? {}
